// extracted by mini-css-extract-plugin
export default {"videoItem":"videoItem__2GIkc"};